export default [
  {
    path: '/admin/stock-in',
    name: 'stock-in',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/stock-in/index.vue')
  },
  {
    path: '/admin/stock-in/create',
    name: 'stock-in-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/stock-in/create.vue')
  },
  {
    path: '/admin/stock-in/:id/edit',
    name: 'stock-in-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/stock-in/edit.vue')
  }
]
